// extracted by mini-css-extract-plugin
export default {"about":"htL5oW3NB3uvWqykQLv0","hi":"IC_TZAbY9m65sHR7QzBD"};